<template>
    <img
        ref="image"
        :srcset="srcset"
        :sizes="sizes"
        :src="src"
        :width="imageWidth"
        :alt="alt"
        @load="updateSizes"
    >
</template>

<script>
import get from 'lodash/get';

export default {
  name: 'ResponsiveImage',
  props: {
    image: {
      type: Object,
      required: true,
    },
    alt: {
      type: String,
      required: false,
      default: '',
    },
    fallbackImage: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      sizes: '1px',
      defaultImage: this.fallbackImage,
    };
  },
  computed: {
    imageWidth() {
		    return get(this.image, 'width');
    },
    src() {
      return get(this.image, 'url', this.defaultImage);
    },
    srcset() {
      return get(this.image, 'srcset', this.src);
    },
  },
  methods: {
    calculateWidth() {
		    if (this.$refs && this.$refs.image) {
        return Math.ceil((this.$refs.image.getBoundingClientRect().width / window.innerWidth) * 100);
      }
    },
    updateSizes() {
      this.sizes = `${this.calculateWidth()}vw`;
    },
  },
};
</script>
